// extracted by mini-css-extract-plugin
module.exports = {"component":"tab_component__IDaA7","wrapper":"tab_wrapper__t7vCm","tab":"tab_tab__nJB6s","count":"tab_count__uArwc","isActive":"tab_isActive__6ozG7"};